import * as Yup from 'yup'

export type VerificationValues = {
  email?: string
  phone?: string
  country_code?: string
  code: string
}
export type RegisterValues = {
  first_name: string
  last_name: string

  phone: string
  password: string
  email: string
  country_code: string
}
export type GuestValues = {
  name: string

  phone: string
  email?: string
  country_code: string
  password?: string
  verification_code?: string
}

export const RegisterSchema = Yup.object().shape({
  first_name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  last_name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  password: Yup.string()
    .min(8, 'استخدم 8 أحرف أو أكثر')
    .max(50, 'Too Long!')
    .required('Required'),
  phone: Yup.string()
    .required()
    .matches(/^[0-9]+$/, 'يجب ادخال رقم الهاتف بدون فواصل'),
  country_code: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
})

export const GuestSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  phone: Yup.string()
    .required()
    .matches(/^[0-9]+$/, 'يجب ادخال رقم الهاتف بدون فواصل'),
  country_code: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
})

export const VerificationSchema = Yup.object().shape({
  code: Yup.string()
    .min(4, 'Too Short!')
    .max(4, 'Too Long!')
    .required('Required'),
})
